module.exports = __webpack_public_path__ + "static/media/spinner.8f887d85.svg";